module.exports = __webpack_public_path__ + "static/media/Cross-Down.56b4a842.png";